import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import configMenu from '@/views/custom-layout/components/configMenu.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
import { isEmpty } from '@/utils';
import mixin from '../../mixin';
export default {
  name: 'magic_nav_config',
  mixins: [mixin],
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    customerPackageList: Array,
    systemMenus: Object,
    tabListFlat: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary,
    configMenu: configMenu
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      defaultList: [],
      showPictureLibrary: false,
      pictureInfo: {},
      pictureList: [],
      updateIndex: 0,
      pictureIndex: 1,
      depot: {}
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key,
        key_type: this.value.config.magic_type
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureInfo = picture;
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config.value[this.updateIndex]['imageurl'] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.pictureIndex = index + 1;
      this.pictureList = this.pictureInfo[this.pictureIndex];
      this.showPictureLibrary = true;
    },
    // 切换选择魔方导航
    changeMagicType: function changeMagicType(item) {
      if (item.magic_type === this.value.config.magic_type) {
        return;
      }
      this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
        magic_type: item.magic_type,
        value: item.default_imageurl.map(function (imageurl) {
          return {
            imageurl: imageurl,
            link_type: '1',
            link_value: '',
            goods_id: ''
          };
        })
      }));
      this.getPicture();
      this.$refs.form.clearValidate();
    },
    onUpload: function onUpload(index) {
      this.$refs["uploadBanner".concat(index)][0].uploadBanner();
    },
    onDelete: function onDelete(item) {
      if (!item.imageurl) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        item.imageurl = '';
      });
    },
    emitUploadFile: function emitUploadFile(res, item, prop) {
      item[prop] = "".concat(this.$ossurl).concat(res);
    },
    getConfig: function getConfig(index, type) {
      return {
        1: {
          0: ['竖图', '250*420'],
          1: ['方图（左）', '200*200'],
          2: ['方图（右）', '200*200'],
          3: ['横图', '420*200']
        },
        2: {
          0: ['方图（左）', '335*204'],
          1: ['方图（右）', '335*204'],
          2: ['横图', '690*153']
        },
        3: {
          0: ['横图', '690*153'],
          1: ['方图（左）', '335*204'],
          2: ['方图（右）', '335*204']
        },
        4: {
          0: ['方图（上）', '335*216'],
          1: ['方图（下）', '335*216'],
          2: ['竖图', '335*452']
        },
        5: {
          0: ['竖图', '335*452'],
          1: ['方图（上）', '335*216'],
          2: ['方图（下）', '335*216']
        },
        6: {
          0: ['方图（左）', '216*216'],
          1: ['方图（中）', '216*216'],
          2: ['方图（右）', '216*216']
        },
        7: {
          0: ['方图（左上）', '335*216'],
          1: ['方图（右上）', '335*216'],
          2: ['方图（左下）', '335*216'],
          3: ['方图（右下）', '335*216']
        },
        8: {
          0: ['图片1', '159*216'],
          1: ['图片2', '159*216'],
          2: ['图片3', '159*216'],
          3: ['图片4', '159*216']
        }
      }[this.value.config.magic_type][index][type];
    }
  },
  created: function created() {
    var _this2 = this;
    var defaultConfig = this.tabListFlat.find(function (i) {
      return i.key === _this2.value.key;
    });
    this.defaultList = (defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.config_default_value) || []; // 赋值可选择的魔方导航列表

    if (isEmpty(this.value.config)) {
      var _this$defaultList$fin, _this$defaultList$fin2;
      var magic_type = this.value.magic_type || '1';
      this.$set(this.value, 'config', {
        magic_type: magic_type,
        value: (_this$defaultList$fin = this.defaultList.find(function (i) {
          return i.magic_type === magic_type;
        })) === null || _this$defaultList$fin === void 0 ? void 0 : (_this$defaultList$fin2 = _this$defaultList$fin.default_imageurl) === null || _this$defaultList$fin2 === void 0 ? void 0 : _this$defaultList$fin2.map(function (imageurl) {
          return {
            imageurl: imageurl,
            link_type: '1',
            link_value: '',
            goods_id: ''
          };
        }),
        prompt_content: '暂未绑卡或卡规则不支持该功能'
      });
    } else {
      this.value.config.value = this.value.config.value.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          link_type: i.link_type + ''
        });
      });
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_,
      _this$value$config$is = _this$value$config.is_show_shadow,
      is_show_shadow = _this$value$config$is === void 0 ? 1 : _this$value$config$is;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index,
      //兼容新老组件 默认预置2
      is_show_shadow: is_show_shadow // 样式6/7默认展示阴影
    }));
    this.getPicture();
  }
};